import {getLabEditDetail} from '../../../services/lab';
import {useQuery} from 'react-query';

const useGetLabInfo = (labId: string) => {
  const {
    data: labEditInfo,
    isLoading,
    isSuccess,
  } = useQuery(['get-edit-info'], () => getLabEditDetail(labId));
  return {labEditInfo, isLoading, isSuccess};
};

export default useGetLabInfo;
